import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { Undef } from 'types/UtilityTypes';
import captureException from 'utils/captureException';

import { QuoteInformationSection } from '../LTL/QuoteInformationSection';
import { useQuickQuoteContext } from '../context/QuickQuoteContext';
import { QuickQuoteInputs } from '../types';
import { fetchSuggestedCustomer } from '../utils/fetchSuggestedCustomer';

type BatchLTLCustomerSectionProps = {
  suggestedCustomerId: Undef<string>;
  // The staff the rep picked before leaving the email.
  preferredStaffOwnerId?: number;
};

// One customer and staff for every shipment; Tai needs both before rating.
export function BatchLTLCustomerSection({
  suggestedCustomerId,
  preferredStaffOwnerId,
}: BatchLTLCustomerSectionProps) {
  // The picker writes the resolved customer and staff into QuickQuoteContext.
  const customerForm = useForm<QuickQuoteInputs>({
    defaultValues: { customerName: suggestedCustomerId ?? '' },
  });
  const { customers, handleCustomerSearch } = useQuickQuoteContext();
  const hasSuggestedCustomer = Boolean(
    customers?.some(
      (customer) => customer.externalTMSID === suggestedCustomerId
    )
  );

  // The suggested customer may not be in the first page of customers; search for it so
  // the picker can resolve it.
  useEffect(() => {
    if (!suggestedCustomerId || hasSuggestedCustomer) {
      return;
    }

    fetchSuggestedCustomer(handleCustomerSearch, suggestedCustomerId).catch(
      (error) =>
        captureException(error, {
          functionName: 'BatchLTLCustomerSection.fetchSuggestedCustomer',
        })
    );
  }, [suggestedCustomerId, hasSuggestedCustomer, handleCustomerSearch]);

  return (
    <QuoteInformationSection
      formMethods={customerForm}
      customerRequired
      showHeading={false}
      preferredStaffOwnerId={preferredStaffOwnerId}
    />
  );
}
